
import {
  EncounterParticipant
} from "@dndModels/encounter";
import { Campaign, CampaignObject } from "@dndModels/character";
import { DataType } from "@dndModels/Types";


export class Encounter extends CampaignObject {
  data_type: DataType = "encounter";
  connected = false;
  old_pieces = false;
  owner_id = "";
  is_favorite = false;
  is_archived = false;
  is_chase = false;

  image_url = "";

  player_ids: string[] = [];
  // campaign_ids: string[] = [];
  // campaigns: Campaign[] = [];

  participants: EncounterParticipant[] = [];
  running = false;
  current_turn_participant_id = "";
  current_initiative = -1;
  description = "";
  trim_stat_blocks = true;
  hide_description = false;
  campaign_id = "";
  campaign: Campaign | undefined = undefined;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.description = obj.description ? obj.description : "";
      this.trim_stat_blocks = obj.trim_stat_blocks !== undefined ? obj.trim_stat_blocks : true;
      this.hide_description = obj.hide_description ? obj.hide_description : false;
      this.campaign_id = obj.campaign_id ? obj.campaign_id : "";
      this.owner_id = obj.owner_id ? obj.owner_id : "";
      // this.campaign_ids = obj.campaign_ids ? obj.campaign_ids : [];
      this.player_ids = obj.player_ids ? obj.player_ids : [];
      this.participants = [];
      if (obj.participants && obj.participants.length) {
        for (const p of obj.participants) {
          if (p.participant_id && p.participant_id !== "") {
            this.participants.push(new EncounterParticipant(p));
          }
        }
      }
      this.image_url = obj.image_url ? obj.image_url : "";
      this.is_favorite = obj.is_favorite ? obj.is_favorite : false;
      this.is_archived = obj.is_archived ? obj.is_archived : false;
      this.is_chase = obj.is_chase ? obj.is_chase : false;
      this.running = obj.running ? obj.running : false;
      this.current_turn_participant_id = obj.current_turn_participant_id ? obj.current_turn_participant_id : "";
      this.current_initiative = obj.current_initiative ? obj.current_initiative : -1;

      // this.campaigns = [];
      this.connected = false;
    }
  }

  toDBObj(): any {
    return {
      _id: this._id,
      name: this.name,
      description: this.description,
      trim_stat_blocks: this.trim_stat_blocks,
      hide_description: this.hide_description,
      owner_id: this.owner_id,
      // campaign_ids: this.campaign_ids,
      player_ids: this.player_ids,
      participants: this.participants.map(o => o.toDBObj()),
      is_favorite: this.is_favorite,
      is_archived: this.is_archived,
      is_chase: this.is_chase,
      image_url: this.image_url,
      running: this.running,
      current_turn_participant_id: this.current_turn_participant_id,
      current_initiative: this.current_initiative,
      campaign_id: this.campaign_id
    };
  }

  clone(drop_ids = false): Encounter {
    const clone = new Encounter();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: Encounter, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.owner_id = copyMe.owner_id;
    this.description = copyMe.description;
    this.campaign_id = copyMe.campaign_id;
    this.campaign = copyMe.campaign;
    this.trim_stat_blocks = copyMe.trim_stat_blocks;
    this.hide_description = copyMe.hide_description;
    // console.log(this.hide_description);
    // this.campaign_ids = [...copyMe.campaign_ids];
    // this.campaigns = [...copyMe.campaigns];
    this.player_ids = [...copyMe.player_ids];
    this.participants = [...copyMe.participants]; // .map(o => { return o instanceof Character ? o : o.clone(); });
    this.connected = copyMe.connected;
    this.is_favorite = copyMe.is_favorite;
    this.is_archived = copyMe.is_archived;
    this.is_chase = copyMe.is_chase;
    this.running = copyMe.running;
    this.current_turn_participant_id = copyMe.current_turn_participant_id;
    this.current_initiative = copyMe.current_initiative;
  }

  add_participants(copyMe: Encounter): void {
    for (const participant of copyMe.participants) {
      if (this.participants.filter(o => o.participant_id === participant.participant_id).length === 0) {
        this.participants.push(participant);
      }
    }
  }
}

// export class EncounterLog extends PlayerObject {
//   game_system: string = "D&D";
//   data_type: string = "encounter_log";
//   encounter_id: string = "";
//   event_time: number = 0; // The time of the event in common_util.get_time_number() format
//   participant_id: string = ""; // "" if it's on the encounter itself
//   field: string = ""; // The property that changed
//   value: any = null; // The value that changed

//   constructor(obj?: any) {
//     super(obj);
//     if (obj) {
//       this.encounter_id = obj.encounter_id ? obj.encounter_id : "";
//       this.event_time = obj.event_time ? obj.event_time : 0;
//       this.participant_id = obj.participant_id ? obj.participant_id : "";
//       this.field = obj.field ? obj.field : "";
//       this.value = obj.value ? obj.value : null;
//     }
//   }

//   toDBObj(): any {
//     return {
//       _id: this._id,
//       encounter_id: this.encounter_id,
//       event_time: this.event_time,
//       participant_id: this.participant_id,
//       field: this.field,
//       value: this.value
//     };
//   }
// }